import {
  IParseResult,
  ParseResult,
  PreParseResult,
  ValueType,
} from '../FormatterTypes';
import { isUtilityKey, isFunctionKey } from '../../parseUtils';


export interface IValidateParams {
  inputsList: string;
  inputValid?: (key: string) => boolean;
  separators: string;
}

abstract class BaseParser {
  protected constructor() {}

  abstract defaultParams(): string;
  abstract parse(text: string, params?: string): IParseResult;

  getValidateParams(params: string): IValidateParams {
    return { inputsList: '', separators: '' };
  }

  maxLength(params: string = ''): number {
    return 0;
  }

  validateOveride(params: string): boolean {
    return false;
  }

  validateKey(
    event: React.KeyboardEvent<unknown>,
    params: string = '',
    keyValue?: string
  ): boolean {
    if (this.validateOveride(params)) {
      return true;
    }

    const key = keyValue ?? event.key;
    const keyCode = event.keyCode;
    const ctrlKey = event.ctrlKey;

    let valid =
      key === 'Unidentified' ||
      isUtilityKey(keyCode) ||
      isFunctionKey(keyCode, ctrlKey);
    if (!valid) {
      const validateParams = this.getValidateParams(params);
      for (let i = 0; i < key.length; i++) {
        valid = this.validateInput(key[i], validateParams);
      }
    }

    return valid;
  }

  validateInput(key: string, validate: IValidateParams): boolean {
    return (
      validate.inputsList.length === 0 ||
      validate.inputValid?.(key) ||
      validate.inputsList.includes(key) ||
      validate.separators.includes(key)
    );
  }

  /**
   * Filters out invalid characters from the input string.
   * @param text - The input text to filter
   * @param params - Parser parameters
   * @returns The filtered text with only valid characters
   */
  filterInvalidCharacters(text: string, params: string = ''): string {
    if (this.validateOveride(params)) {
      return text;
    }

    const validateParams = this.getValidateParams(params);

    let filteredText = '';
    for (let i = 0; i < text.length; i++) {
      const char = text[i];
      if (this.validateInput(char, validateParams)) {
        filteredText += char;
      }
    }
    return filteredText;
  }

  hasPreparser(): boolean {
    return false;
  }

  preParse(text: string, params: string = ''): IParseResult {
    return { value: '', result: PreParseResult.UNDEFINED };
  }

  errorMessage(
    text: string,
    parseResult: IParseResult,
    params: string = '',
    caption: string = ''
  ): string {
    if (parseResult.result > ParseResult.OK) {
      return `Ogiltigt värde "${text}" i ${caption}.`;
    } else if (parseResult.result < ParseResult.OK) {
      return `Kontrollera värdet "${text}" i ${caption}.`;
    } else {
      return '';
    }
  }

  raiseError(
    text: string,
    parseResult: IParseResult,
    params: string = '',
    caption: string = '',
    sender: string = '',
    unitName: string = '',
    procName: string = ''
  ) {
    // Slutade compila när IParseValues ändrades så values kan vara undefined
    // if (parseResult.result > ParseResultCodes.PARSE_OK) {
    //   // Kan behöva lägga in mer info i error meddelandet, från delphi
    //   throw new ParseError(
    //     this.errorMessage(text, parseResult, params, caption)
    //   );
    // }
  }

  checkParse(
    text: string,
    params: string = '',
    caption: string = '',
    sender: string = '',
    unitName: string = '',
    procName: string = ''
  ): void {
    let prcName = procName ? procName : typeof this + '.CheckParse';
    this.raiseError(
      text,
      this.parse(text, params),
      params,
      caption,
      sender,
      unitName,
      prcName
    );
  }

  parseDef(
    text: string,
    defaultValue: ValueType,
    params: string = ''
  ): IParseResult {
    //   const parseResult = this.parse(text, params);
    //   if (parseResult.result > ParseResultCodes.PARSE_OK || !parseResult.result) {
    //     return { value: defaultValue, result: parseResult.result };
    //   }

    //   return parseResult;
    // }
    return {
      result: ParseResult.ERROR,
      value: null,
    };
  }
}

export { BaseParser };
